import React from "react"
import {
  LoadScript,
  GoogleMap,
  Marker,
  Polyline
} from "@react-google-maps/api"

const containerStyle = {
  height: '50vh',
  width:'100%'
};

const Map = (props) => <LoadScript
      loadingElement={<div style={{ height: `100%` }} />}
      googleMapsApiKey={props.googleMapsApiKey}
    >
    <GoogleMap
       mapContainerStyle={containerStyle}
      zoom={props.zoom}
      center={props.center}
    >
      {props.markers.map((marker, index) => {
        const position = { lat: marker.lat, lng: marker.lng }
        return <Marker key={index} position={position} />
      })}
      <Polyline path={props.markers.map(o => { return {lat: o.lat, lng: o.lng} })} options={{ strokeOpacity: 0.8, strokeColor: "teal", fillColor:"teal"}}/>
    </GoogleMap>
    </LoadScript>

export default Map